module.exports = __webpack_public_path__ + "static/media/Aloha-Mundo.5af00250.ogv";